import React from 'react';
import cx from 'classnames';

import {  Image } from 'react-bootstrap';
import Truncate from 'src/components/truncate';

import styles from './Style.module.scss';
import { localizedStrings } from 'src/localization';
class EmailOptionView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      options: this.props.contacts
    }

    this._handleOptionSelected = this._handleOptionSelected.bind(this);

    // localized contents
    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonActions = localizedStrings.commons.actions;
    this.localizedHub = localizedStrings.pages.hub;
  }

  _handleOptionSelected(contact){
    if(this.props.setValue){
      this.props.setValue(contact);
    }
  }

  render() {
    return (
      <div className={cx(styles.option)}>
        {this.renderOption(this.props.option)}
      </div>
    );
  }

  renderOption(option){
    if(option.type == 'contact'){
      return this.renderContact(option.value);
    }else if(option.type == 'contact_list'){
      return this.renderContactList(option.value);
    }else if(option.type == 'option_group'){
      return this.renderOptionGroup(option);
    }
  }

  renderContact(contact){
    return (
      <div key={contact.id} className={styles.contact} onClick={() => this._handleOptionSelected(contact)}>
      <div className={styles.left}>
        <div className={styles.iconContainer}>
          {!contact.icon &&
            <div className={styles.contactAvatar}>
            <i className="paperflite-user-settings" />
             </div>}
          {contact.icon &&
            <Image className={styles.contactIcon} src={contact.icon.thumbnail} roundedCircle />}
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.contactName}>
          <Truncate width={200} lines={1}> {this.renderName(contact)} </Truncate>
        </div>
        <div className={styles.contactTitle}>
          <Truncate width={200} lines={1}> {contact.email || 'No Details'} </Truncate>
        </div>
      </div>
    </div>
    );
  }

  renderContactList(contactList){
    return (
      <div key={contactList.id} className={styles.contactList} onClick={() => this._handleOptionSelected(contactList)}>
      <div className={styles.left}>
        <div className={styles.icon}>
          <div className={styles.avatar}>
          <i className="paperflite-group" />  </div>
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.name}>
          <Truncate lines={1}> {contactList.name} </Truncate>
        </div>
        <div className={styles.members}>
          {contactList.contactCount} {this.localizedCommons.contacts}
        </div>
      </div>
      </div>
    );
  }

  renderOptionGroup(optionGroup){
    return (
      <div className={styles.optionGroup}>
        {optionGroup.fetching && 
           `${this.localizedCommons.contacts_search.searching_contacts}...`
        }

        {optionGroup.empty && 
          `${this.localizedCommons.contacts_search.no_contacts_found}`
        }
      </div>
    );
  }

  renderName(contact){
    return `${contact.firstName || ''} ${contact.lastName || ''}`
  }
}

export default EmailOptionView;